import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
    faApple,
    faFacebook,
    faInstagram,
    faLinkedin,
    faPinterest,
    faTwitter,
    faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { faCoin } from "@fortawesome/pro-light-svg-icons";
import {
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAnglesDown,
    faAnglesLeft,
    faAnglesRight,
    faAnglesUp,
    faAngleUp,
    faArrowDown,
    faArrowDownFromLine,
    faArrowLeft,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowRightFromBracket,
    faArrowsUpDownLeftRight,
    faArrowUp,
    faArrowUpRightFromSquare,
    faArrowUpToLine,
    faBan,
    faBars,
    faBed,
    faBicycle,
    faBolt,
    faBoxArchive,
    faCalendar,
    faCalendarDay,
    faCamera,
    faCheck,
    faChildReaching,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleCheck,
    faCircleExclamation,
    faCircleUser,
    faClock,
    faClockRotateLeft,
    faCoins,
    faComment,
    faCommentPen,
    faComments,
    faCompass,
    faCopy,
    faDogLeashed,
    faDoorClosed,
    faEnvelope,
    faExclamation,
    faFileImage,
    faFileImport,
    faFileLines,
    faFilter,
    faFlagSwallowtail,
    faFloppyDisk,
    faGear,
    faHandHoldingHeart,
    faHeart,
    faHouseChimney,
    faHouseTree,
    faHouseUser,
    faKey,
    faLink,
    faList,
    faListCheck,
    faLocationDot,
    faLockKeyhole,
    faMagnifyingGlass,
    faMap,
    faMinus,
    faPencil,
    faPersonHiking,
    faPhone,
    faPlus,
    faReceipt,
    faReply,
    faReplyAll,
    faRotateLeft,
    faRotateRight,
    faShareNodes,
    faSort,
    faSortDown,
    faSortUp,
    faStar,
    faStarHalf,
    faStopwatch,
    faTag,
    faTrashCan,
    faTreeDeciduous,
    faTriangleExclamation,
    faUser,
    faUserGroup,
    faWaterLadder,
    faWifi,
    faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
    faCircleInfo,
    faEllipsis,
    faEllipsisVertical,
    faHeart as faHeartFilled,
    faInfo,
    faLocationCrosshairs,
} from "@fortawesome/pro-solid-svg-icons";
import BarsCustom from "@/assets/icons/bars_custom.svg?react";
import Description from "@/assets/icons/description.svg?react";
import Euro from "@/assets/icons/euro.svg?react";
import GoogleCustom from "@/assets/icons/google.svg?react";
import ImpactLevel1 from "@/assets/icons/impact-level-1.svg?react";
import ImpactLevel2 from "@/assets/icons/impact-level-2.svg?react";
import ImpactLevel3 from "@/assets/icons/impact-level-3.svg?react";
import Leaf from "@/assets/icons/leaf.svg?react";
import NHMarker from "@/assets/icons/nh-marker.svg?react";
import NoPets from "@/assets/icons/no-pets.svg?react";
import Rotate from "@/assets/icons/rotate.svg?react";
import Steps from "@/assets/icons/steps.svg?react";
import type { CustomIcon } from "*.svg?react";

const faIcons: Record<string, IconDefinition> = {
    deposit: faCoin,
    door: faDoorClosed,
    secure: faLockKeyhole,
    history: faClockRotateLeft,
    arrowRight: faAngleRight,
    arrowLeft: faAngleLeft,
    arrowDown: faAngleDown,
    arrowUp: faAngleUp,
    doubleArrowRight: faAnglesRight,
    doubleArrowLeft: faAnglesLeft,
    doubleArrowUp: faAnglesUp,
    doubleArrowDown: faAnglesDown,
    start: faArrowRightFromBracket,
    directionRight: faArrowRight,
    directionLeft: faArrowLeft,
    directionUp: faArrowUp,
    directionDown: faArrowDown,
    exchange: faArrowRightArrowLeft,
    externalLink: faArrowUpRightFromSquare,
    move: faArrowsUpDownLeftRight,
    block: faBan,
    menu: faBars,
    bed: faBed,
    amenities: faBicycle,
    instantBooking: faBolt,
    archived: faBoxArchive,
    calendar: faCalendar,
    period: faCalendarDay,
    photos: faCamera,
    check: faCheck,
    child: faChildReaching,
    circleDirectionRight: faCircleArrowRight,
    circleDirectionLeft: faCircleArrowLeft,
    circleDirectionUp: faCircleArrowUp,
    circleDirectionDown: faCircleArrowDown,
    success: faCircleCheck,
    circleInfo: faCircleInfo,
    spinner: faSpinnerThird,
    account: faCircleUser,
    error: faCircleExclamation,
    clock: faClock,
    upload: faArrowUpToLine,
    download: faArrowDownFromLine,
    extraCosts: faCoins,
    chat: faComment,
    rate: faCommentPen,
    comments: faComments,
    location: faCompass,
    pets: faDogLeashed,
    mail: faEnvelope,
    exclamation: faExclamation,
    fileImage: faFileImage,
    document: faFileLines,
    filter: faFilter,
    flag: faFlagSwallowtail,
    save: faFloppyDisk,
    settings: faGear,
    charity: faHandHoldingHeart,
    heart: faHeart,
    home: faHouseChimney,
    houses: faHouseTree,
    accountHome: faHouseUser,
    key: faKey,
    connect: faLink,
    list: faList,
    rules: faListCheck,
    search: faMagnifyingGlass,
    map: faMap,
    minus: faMinus,
    edit: faPencil,
    activities: faPersonHiking,
    plus: faPlus,
    receipt: faReceipt,
    reply: faReply,
    replyAll: faReplyAll,
    refresh: faRotateRight,
    share: faShareNodes,
    sort: faSort,
    sortDown: faSortDown,
    sortUp: faSortUp,
    star: faStar,
    starHalf: faStarHalf,
    stopwatch: faStopwatch,
    tag: faTag,
    delete: faTrashCan,
    tree: faTreeDeciduous,
    warning: faTriangleExclamation,
    user: faUser,
    travelParty: faUserGroup,
    swimmingPool: faWaterLadder,
    wifi: faWifi,
    close: faXmark,
    marker: faLocationDot,
    copy: faCopy,
    import: faFileImport,
    undo: faRotateLeft,
    phone: faPhone,
    heartFilled: faHeartFilled,
    tip: faCircleInfo,
    info: faInfo,
    crosshair: faLocationCrosshairs,
    moreVertical: faEllipsisVertical,
    moreHorizontal: faEllipsis,
    facebook: faFacebook,
    instagram: faInstagram,
    linkedin: faLinkedin,
    pinterest: faPinterest,
    twitter: faTwitter,
    whatsapp: faWhatsapp,
    apple: faApple,
};

const customIcons: Record<string, CustomIcon> = {
    google: GoogleCustom,
    description: Description,
    euro: Euro,
    leaf: Leaf,
    noPets: NoPets,
    rotate: Rotate,
    steps: Steps,
    bars: BarsCustom,
    impactLevel1: ImpactLevel1,
    impactLevel2: ImpactLevel2,
    impactLevel3: ImpactLevel3,
    nhMarker: NHMarker,
};

const icons = {
    ...faIcons,
    ...customIcons,
};

export type IconType = keyof typeof icons;

export default icons;
